// redux/slices/branchesSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchBranches = createAsyncThunk(
  "branches/fetchBranches",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/branches`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch branches");
    }
  }
);

export const fetchBranchById = createAsyncThunk(
  "branches/fetchBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/branches/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch branch by ID");
    }
  }
);

const branchesSlice = createSlice({
  name: "branches",
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchBranchById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBranchById.fulfilled, (state, action) => {
        state.loading = false;
        state.current = action.payload;
      })
      .addCase(fetchBranchById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectAllBranches = (state) => state.branches.list;
export const selectCurrentBranch = (state) => state.branches.current;
export const selectBranchesLoading = (state) => state.branches.loading;
export const selectBranchesError = (state) => state.branches.error;

export default branchesSlice.reducer;
